export default class Connector {
  constructor(adGroupTypeView, bidStrategyView) {
    this.adGroupTypeView = adGroupTypeView;
    this.adGroupTypeView.on('change:BidOption', (adGroupType) => {
      bidStrategyView.onAdGroupTypeChanged(adGroupType);
    });
  }

  stopListening() {
    this.adGroupTypeView.off('change:BidOption');
  }
}
